import Card from '@rio-cloud/rio-uikit/Card';
import { type ReactNode, useState } from 'react';

export type SelectableCardProps = {
    icon: string;
    title: ReactNode;
    description: ReactNode;
    selected: boolean;
    onClick: () => void;
};

const SelectableCard = ({ icon, title, description, selected, onClick }: SelectableCardProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const isHighlighted = isHovered || selected;
    const highlightTextClass = isHighlighted ? 'text-color-highlight' : 'text-color-darker';

    return (
        <Card
            className={`display-flex cursor-pointer user-select-none width-100pct${
                selected ? ' bg-highlight-lightest' : ' bg-white'
            }${isHighlighted ? ' border-color-highlight' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
        >
            <div className='display-flex flex-1-1 flex-column align-items-start gap-5'>
                <span className={`text-size-16 rioglyph rioglyph-${icon} ${highlightTextClass}`} />
                <div className={`text-size-14 text-medium ${highlightTextClass}`}>{title}</div>
                <div className='text-size-12 text-color-gray'>{description}</div>
            </div>
        </Card>
    );
};

export default SelectableCard;
